module.exports = __webpack_public_path__ + "img/spinner-white.2165bb33.svg";